import { Injectable } from '@angular/core';
import { ApiConnector, ApiSettings } from '@frontend/util/api-connector';
import { filter, Observable, switchMap } from 'rxjs';
import { isNotNullOrUndefined } from '@frontend/util/type-guards';
import { HttpHeaders } from '@angular/common/http';
import { httpRetryer } from '@frontend/util/http-utilities';

@Injectable({
  providedIn: 'root',
})
export class CampaignScoringService extends ApiConnector<{
  HUB_ANALYTICS_API_URL: string;
}> {
  protected baseUrl = this.env.HUB_ANALYTICS_API_URL;

  protected authToken$ = this.authService.hubIdpToken$;

  protected defaultSettings = ApiSettings({
    authorizationBearerToken: this.authToken$.pipe(
      filter(isNotNullOrUndefined),
    ),
    authorizePath: '/v1/authorize',
  });

  getRevenueGroups = this.endpoint<any, string[]>({
    method: 'GET',
    path: '/api/v1/revenue_groups',
  });
  loadAttributionSelections = this.endpoint<any, any>({
    method: 'GET',
    path: '/orgAdmin/load_attribution_selections',
  });
  loadConfig = this.endpoint<any, any>({
    method: 'GET',
    path: '/api/v1/load_config',
  });
  loadOpportinityContactRoles = this.endpoint<any, string[]>({
    method: 'GET',
    path: '/api/v1/load_opportinity_contact_roles',
  });
  updateAttribution = this.postEndpoint<any, any>(
    '/orgAdmin/update_attribution',
  );
  updateConfig = this.endpoint<any, any>({
    method: 'POST',
    path: '/orgAdmin/update_config',
  });

  private postEndpoint<T, R>(url: string): (p: T) => Observable<R> {
    return (payload: T): Observable<R> =>
      this.authToken$.pipe(
        switchMap((authToken) =>
          this.httpClient.request<R>('POST', `${this.baseUrl}${url}`, {
            body: payload,
            responseType: 'text' as 'json',
            headers: new HttpHeaders({
              authorization: `Bearer ${authToken}`,
            }),
          }),
        ),
        httpRetryer({}),
      );
  }
}
